import axios from 'axios';
import { CircleMinus, CirclePlus, SquareMinus, SquarePlus } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

import { SuggestedField } from 'base/ui/suggested_field';
import { useRerenderWithValue } from 'base/utils/common';

import CatalogProduct from '../store/product/CatalogProduct';


function SuggestedProduct ({cp, delivery_route}) {
    return (
      <CatalogProduct delivery_route={delivery_route} catalog_product={cp} price={cp.price} can_modify={false} />
    )
}
  
function SelectedProduct ({cp, delivery_route, onQtyChange, onRemove}) {
    const [qty, setQty] = useState(1);
  
    const updateQty = (val) => {
      val = parseInt(val) || 0;
      val = Math.max(1, Math.min(val, cp.max_qty_per_user || 500, cp.qty));
      // play a sound
      setQty(val);
      val !== qty && onQtyChange(val, cp);
    }
  
    return (
      <div className='tw-w-full tw-flex tw-justify-between tw-gap-2 tw-px-2 tw-bg-white tw-text-xs tw-items-center' key={cp._id} onClick={(e) => e.preventDefault()}>
        <SuggestedProduct cp={cp} delivery_route={delivery_route} />
        <div>
          <div className='tw-flex tw-items-center app-qty-change'>
            <CircleMinus size={20} className={qty > 1 ? "" : "tw-text-gray-400"} onClick={() => updateQty(qty - 1)} />
            &nbsp;&nbsp;<span>{qty || 1}</span>&nbsp;&nbsp;
            <CirclePlus size={20} className="" onClick={() => updateQty(qty + 1)} />
          </div>
        </div>
        <button type='button' className='tw-text-red-500 tw-text-xs tw-p-2' onClick={onRemove}>
          Remove
        </button>
      </div>
    )
}
  
  function SelectProducts({delivery_route, onSelect, max_selections, className, input_className, show_float_label, is_disabled, display_product_image = true}) {
    const ctx = useRef({}).current;
    const [rerender, setRerender] = useRerenderWithValue()

    useEffect(() => {
      setRerender()
    }, [delivery_route])
    
  
    const onProductsSelect = (products) => {
      const new_products_qty = {};
      products?.forEach(cp => {new_products_qty[cp._id] = ctx.products_qty?.[cp._id] || 1});
      ctx.products_qty = new_products_qty;
      ctx.products = products;
      onSelect({products, products_qty: new_products_qty});
    }
  
    const onProductQtyChange = (qty, cp) => {
      ctx.products_qty[cp._id] = qty;
      onSelect({products: ctx.products, products_qty: ctx.products_qty});
    }

    return (
        <div className='tw-relative'>
            <SuggestedField
                key={rerender}
                className={className}
                input_className={`${show_float_label ? 'floating-label-input' : ''} ${input_className}`}
                props={{
                    "endpoint": `/api/products/search/${delivery_route._id}`,
                    "results_key_path": "catalog_products",
                    "max_selections": max_selections || 10,
                    "placeholder": "Search for Products",
                    "result_renderer": (cp) => <SuggestedProduct cp={cp} delivery_route={delivery_route} />,
                    "selected_renderer": (cp, onRemove) => <SelectedProduct cp={cp} delivery_route={delivery_route} onQtyChange={onProductQtyChange} onRemove={onRemove} display_product_image={display_product_image} />,
                    "is_disabled": is_disabled
                }}
                selected={[]}
                onSelect={onProductsSelect}
            />
            {show_float_label ? <label className='floating-label'>{max_selections === 1 ? 'Select Product' : 'Select products'}</label> : null}
        </div>
    )
}

export default SelectProducts
